import React from "react";
import "../css/Pages.css";

export default function NotFound() {
    return (
        <div className="pages">
          <h1>My 404 Not found</h1>
        </div>
  );
};